var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.5C4.925 0.5 0 5.425 0 11.5C0 17.575 4.925 22.5 11 22.5C17.075 22.5 22 17.575 22 11.5C22 5.425 17.075 0.5 11 0.5ZM12 15.5C12 15.7652 11.8946 16.0196 11.7071 16.2071C11.5196 16.3946 11.2652 16.5 11 16.5C10.7348 16.5 10.4804 16.3946 10.2929 16.2071C10.1054 16.0196 10 15.7652 10 15.5V12.5H7C6.73478 12.5 6.48043 12.3946 6.29289 12.2071C6.10536 12.0196 6 11.7652 6 11.5C6 11.2348 6.10536 10.9804 6.29289 10.7929C6.48043 10.6054 6.73478 10.5 7 10.5H10V7.5C10 7.23478 10.1054 6.98043 10.2929 6.79289C10.4804 6.60536 10.7348 6.5 11 6.5C11.2652 6.5 11.5196 6.60536 11.7071 6.79289C11.8946 6.98043 12 7.23478 12 7.5V10.5H15C15.2652 10.5 15.5196 10.6054 15.7071 10.7929C15.8946 10.9804 16 11.2348 16 11.5C16 11.7652 15.8946 12.0196 15.7071 12.2071C15.5196 12.3946 15.2652 12.5 15 12.5H12V15.5Z",
    fill: "#FF8A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.d7a30e17d60a4c63defe0326b6d2f506.svg";
export { ForwardRef as ReactComponent };